import { salesDataClientSourceApprove } from 'commons/service/bank/salesData'
import { WriteHook, useMutationManager } from 'state-manager'

export const useSalesDataClientSourceApprove: WriteHook<number, void> = (opts) =>
  useMutationManager<number, void>(salesDataClientSourceApprove, opts)
